import { ChangeDetectorRef,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import * as moment from 'moment'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { LOCALE_ID } from '@angular/core';
import { eq } from 'lodash';

@Component({
	selector: 'atyl-form-input-date',
	templateUrl: './form-input-date.component.html',
	styleUrls: ['./form-input-date.component.scss'],
	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
export class FormInputDateComponent implements OnInit {

	constructor(
		private readonly inputLabelPipe: InputLabelPipe,
		private cdr: ChangeDetectorRef
	) {

	}
	@Input() forminput: FormAtylBase<any>;;
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>();
	label: string
	errorString: string
	tempTime: any

	minDate:Date;
	maxDate:Date;

	ngOnInit(): void {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		
		//console.log("FormInputDateComponent init",this.forminput);
		
		if(this.forminput && this.group.get(this.forminput.ID) &&  this.group.get(this.forminput.ID).value != "")
                {
                   let value:any=this.group.get(this.forminput.ID).value;
                    console.log("FormInputDateComponent group",value);
             
                  let actualDate = moment.parseZone(value);
                   console.log("iso before",actualDate.toISOString());
                   console.log("iso before",actualDate);
               //   actualDate.set('hour', value.split(':')[0])
                //  actualDate.set('minute', value.split(':')[1])
                 /* actualDate.set('hour', 0);
                  actualDate.set('minute', 0);*/
                //   actualDate.set('second', 0);
                 // console.log(actualDate.format("DD/MM/YYYY"));
                 // this.group.get(this.forminput.ID).setValue(actualDate.format("YYYY-MM-DD"));
                  this.group.get(this.forminput.ID).setValue(actualDate);
                  
                  console.log("iso after",actualDate.toISOString());
                 /* if (this.cdr && !(this.cdr as ViewRef).destroyed) {
                    this.cdr.detectChanges()
                     console.log("FormInputDateComponent group after", this.group.get(this.forminput.ID),this.forminput.value);
                }*/
         }
		
		 const re = /now(\+|\-)?([0-9]+)*(d|m|y)?/;
		
		if (this.forminput && this.forminput.options!=undefined &&  this.forminput.options["min"]!=undefined) {
			
			let foundMin:any= this.forminput.options["min"].match(re);
			if (foundMin)
				this.minDate=this.__getDateFromFormat( foundMin);
			else {
				let dt:any=(isNaN(Date.parse(this.forminput.options["min"])) )? null : new Date (Date.parse(this.forminput.options["min"]));
			//	console.log("FormInputDateComponent min",this.forminput.options["min"],dt,dt instanceof Date);
				if (dt instanceof Date)
					this.minDate=dt;
			}
		}
		
		if (this.forminput && this.forminput.options!=undefined && this.forminput.options["max"]!=undefined) {
			let foundMax:any= this.forminput.options["max"].match(re);
				if (foundMax)
						this.maxDate=this.__getDateFromFormat(foundMax);
				else {
					let dt:any=(isNaN(Date.parse(this.forminput.options["max"])) )? null : new Date (Date.parse(this.forminput.options["max"]));
					// console.log("FormInputDateComponent min",this.forminput.options["max"],dt,dt instanceof Date);			
					if (dt instanceof Date)
						this.maxDate=dt;
				}
		}
	}
	
	__getDateFromFormat(found:any) {
		let dt:Date=new Date();
		
		if (found && Array.isArray(found)) {
			//console.log("FormInputDateComponent matchh",found)
			let sign:string=undefined;
			let vl:number=undefined;
			let ft:string=undefined;
			if (found[1]!=undefined)
				sign=found[1];
			if (found[2]!=undefined)
			   vl=found[2];
			if (found[3]!=undefined)
				ft=found[3];		
			if (sign!=undefined && vl!=undefined&& ft!=undefined) {
				if (ft=="m") {
					dt=new Date(dt.setMonth((sign=="-") ? dt.getMonth() - vl : dt.getMonth() + vl));
				}
				
				if (ft=="d") {
					dt=new Date(dt.setDate((sign=="-") ? dt.getDate() - vl : dt.getDate() + vl));
				}
				
				if (ft=="y") {
					dt=new Date(dt.setFullYear((sign=="-") ? dt.getFullYear() - vl : dt.getFullYear() + vl));									
				}						
			}
		}
		
		return dt;
		
	}	
	
	addTimeToDate(forminput: any, value?: any) {
		console.log("addTimeToDate",this.group.get(this.forminput.ID),
		this.group.get(this.forminput.ID).value,
		 value,this.tempTime);
		if (this.group.get(this.forminput.ID).value) {
			let stdate:string=this.group.get(this.forminput.ID).value.format("YYYY-MM-DDTHH:mm:ss")+"Z"
			let reg:any=/([0-9]{4}-[0-9]{2}-[0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})Z/;
			let vl:any;
			if (value) { 
				vl=value;
				this.tempTime = value
			}
			else if (this.tempTime) {
				vl=this.tempTime;
			}
			if (vl!=undefined) {
				var vll=vl.split(':')
				console.log("addTimeToDate repalce before",stdate);
				stdate=stdate.replace(reg,"$1T" + vll[0] + ":"+ vll[1] + ":$3Z");
				console.log("addTimeToDate repalce after",stdate);
			}
			let actualDate =moment.parseZone(stdate);
			this.group.get(this.forminput.ID).setValue(actualDate)
			console.log("addTimeToDate after",actualDate);
			/*
			let actualDate =moment.parseZone(stdate).utcOffset(0, false);
			console.log("addTimeToDate format",stdate,actualDate);
			if (value) {
				this.tempTime = value
				//let actualDate = moment.parseZone(this.group.get(this.forminput.ID).value).utcOffset(0, false)
	
				actualDate.set('hour', value.split(':')[0])
				actualDate.set('minute', value.split(':')[1])
				this.group.get(this.forminput.ID).setValue(actualDate)
			//	this.group.get(this.forminput.ID).setValue(actualDate.toISOString())
				console.log("addTimeToDate after",actualDate);
			}
			else if (this.tempTime) {
				//let actualDate = moment.parseZone(this.group.get(this.forminput.ID).value).utcOffset(0, false)
				actualDate.set('hour', Number(this.tempTime.split(':')[0]))
				actualDate.set('minute', Number(this.tempTime.split(':')[1]))
				//this.group.get(this.forminput.ID).setValue(actualDate.toISOString())
				this.group.get(this.forminput.ID).setValue(actualDate)
				console.log("addTimeToDate after2",actualDate);
			}
			else {
				//let actualDate = moment.parseZone(this.group.get(this.forminput.ID).value).utcOffset(0, false)
			//this.group.get(this.forminput.ID).setValue(actualDate.toISOString())
				this.group.get(this.forminput.ID).setValue(actualDate)
				console.log("addTimeToDate after3",actualDate);
			}*/
		}
		else {
			//this.group.get(this.forminput.ID).setValue('')
			let actualDate= moment.parseZone().utcOffset(0, false)
			if (value) {
				this.tempTime = value
				actualDate.set('hour', Number(this.tempTime.split(':')[0]))
				actualDate.set('minute', Number(this.tempTime.split(':')[1]))
			}
			this.group.get(this.forminput.ID).setValue(actualDate)
			
		}
		console.log("addTimeToDate after",this.group.get(this.forminput.ID).value, value,this.tempTime);
	}
	replaceValue(newValue: any) {
		this.group.get(String(this.forminput.ID)).setValue(newValue.value)
	}
}
